import { useState } from 'react';

function CoreConceptOfStockInvestingModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to Investing",
      content: [
        "What is Investing?",
        "Definition and purpose of investing.",
        "Difference between investing and saving.",
        "Overview of risk and reward in investing."
      ]
    },
    {
      title: "Module 2: Understanding Different Asset Classes",
      content: [
        "Types of Investments",
        "Equities (Stocks), Bonds, Mutual Funds, ETFs, Real Estate, Commodities.",
        "Risk and return characteristics of each asset class.",
        "How asset classes interact in a portfolio."
      ]
    },
    {
      title: "Module 3: The Power of Compounding",
      content: [
        "Compounding Basics",
        "Concept of compound interest.",
        "How reinvested returns grow wealth over time.",
        "The importance of starting early in investing."
      ]
    },
    {
      title: "Module 4: Risk and Return",
      content: [
        "Understanding Risk",
        "Types of investment risks (market, credit, interest rate, inflation).",
        "Measuring risk: Standard deviation, beta, and other metrics.",
        "Balancing risk and return based on individual goals."
      ]
    },
    {
      title: "Module 5: Investment Strategies",
      content: [
        "Types of Investment Strategies",
        "Long-Term Investing: Buy and hold, the importance of patience.",
        "Short-Term Investing: Trading strategies, market timing.",
        "Dividend Investing: Building passive income.",
        "Growth vs. Value Investing: Focus on capital appreciation or undervalued assets."
      ]
    },
    {
      title: "Module 6: Diversification and Portfolio Management",
      content: [
        "Why Diversify?",
        "The benefits of spreading investments across asset classes, sectors, and geographies.",
        "How diversification reduces risk and enhances returns.",
        "Portfolio rebalancing: Adjusting asset allocation to maintain risk tolerance."
      ]
    },
    {
      title: "Module 7: Understanding Market Trends and Cycles",
      content: [
        "Market Behavior",
        "Understanding bull and bear markets.",
        "Market cycles and economic indicators.",
        "Identifying trends and timing investments."
      ]
    },
    {
      title: "Module 8: Fundamental Analysis",
      content: [
        "Evaluating Investment Opportunities",
        "Understanding company financials (income statements, balance sheets).",
        "Key ratios: P/E, P/B, EPS, and ROE.",
        "Evaluating the health of an economy and sectors."
      ]
    },
    {
      title: "Module 9: Technical Analysis Basics",
      content: [
        "Introduction to Technical Analysis",
        "Basics of price charts: Candlestick, line, and bar charts.",
        "Key patterns: Head and shoulders, moving averages, support, and resistance.",
        "Using technical indicators (RSI, MACD, Bollinger Bands) to inform decisions."
      ]
    },
    {
      title: "Module 10: Behavioral Finance and Investor Psychology",
      content: [
        "Psychology of Investing",
        "Emotional biases that affect decision-making (fear, greed, herd mentality).",
        "Strategies to overcome common biases (loss aversion, overconfidence).",
        "Developing a disciplined and rational investment mindset."
      ]
    },
    {
      title: "Module 11: Taxes and Costs of Investing",
      content: [
        "Understanding Investment Costs",
        "Fees and expenses in mutual funds, ETFs, and brokerage accounts.",
        "Taxation of different investments (capital gains, dividends, interest).",
        "Tax-efficient investing strategies."
      ]
    },
    {
      title: "Module 12: Developing an Investment Plan",
      content: [
        "Creating a Personalized Investment Strategy",
        "Setting financial goals and time horizons.",
        "Aligning investments with risk tolerance and financial objectives.",
        "Monitoring, evaluating, and adjusting the plan as needed."
      ]
    }
  ];

  return (
    <div className="container-fluid">
      <div className="container">
        <h1 className="text-center py-5">Core Concepts of Stock Investing</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div
              key={index}
              className="col-12 col-md-5 mb-3 d-flex flex-column align-items-center"
              style={{ marginBottom: '10px' }}
            >
              {/* Accordion Heading */}
              <div
                className="w-100 p-3 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: '18px',
                    transform: openModule === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s'
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Accordion Content */}
              {openModule === index && (
                <div
                  className="w-100 p-3"
                  style={{
                    border: '1px solid #ddd',
                    borderTop: 'none',
                    backgroundColor: '#ffffff'
                  }}
                >
                  {module.content.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '8px',
                        backgroundColor: '#fdfdfd'
                      }}
                    >
                      <span style={{ color: '#007bff', marginRight: '8px' }}>➤</span>
                      <p className="m-0" style={{ fontSize: '14px', color: '#333' }}>
                        {item}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CoreConceptOfStockInvestingModule;
